import React from "react";

// This component is a copy of
// https://github.com/mozilla-services/react-jsonschema-form/blob/e4378c2a0b738eeee151e82c4533d2a79b80346c/src/components/fields/SchemaField.js#L76L95
// The ErrorList function defined by RJSF is not exported, so there's no way to re-use it

export default (props) => {
  const { errors = [] } = props;
  if (errors.length === 0) {
    return <div />;
  }
  return (
    <div>
      <p />
      <ul className="error-detail bs-callout bs-callout-info">
        {errors.map((error, index) => {
          return (
            <li className="text-danger" key={index}>
              {error}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
